import React, { Component } from 'react';
import EirButton from '../eir-button/EirButton';
import Routing from '../../utils/Routing';
import { currentUser } from '../../services/CurrentUser';
import Constants from '../../Constants';
import PubSub from 'pubsub-js';

class CartSummary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bundleToShow: null,
      plansToShow: [],
      deviceToShow: null
    };
  }

  componentDidMount(){
    this.cartContentChangedToken = PubSub.subscribe(Constants.eventKeys.cartContentChanged, this.cartContentChanged);
    PubSub.publish(Constants.eventKeys.cartSubscriberAdded);
  }

  cartContentChanged = (msg, cart) => {

    let bundleToShow = null;
    let plansToShow = [];
    let deviceToShow = null;
    let cta = null ;

    if ((!cart.temporary || this.props.showTemporaryOrders) && cart.bundle && cart.bundle.plans && cart.bundle.plans.length > 0 && (!this.props.restrictBundlesTo || this.props.restrictBundlesTo.includes(cart.bundle.type))) {
      // show the bundle if it is Not a 1p bundle
      if (this.props.showBundle && cart.bundle.plans.length > 1) {
        bundleToShow = cart.bundle;
        cta = this.createCTA(this.props.removeItemCTAText, bundleToShow.removeUrl);
        bundleToShow.cta = cta;
      } 

      let includedPlans = cart.bundle.plans.filter(plan => !this.props.restrictPlansTo || this.props.restrictPlansTo.includes(plan.type));
      if (this.props.showPlans) {
        plansToShow = includedPlans;

        if (!cta && plansToShow && plansToShow.length > 0) {
          cta = this.createCTA(this.props.changeItemCTAText, plansToShow[0].removeUrl);
          plansToShow[0].cta = cta;
        }
      }

      if (this.props.showDevice) {
        let plansWithDevices = includedPlans.filter(plan => plan.device != null);
        
        if (plansWithDevices.length > 0) {
          deviceToShow = plansWithDevices[0].device;
        }

        if (!cta && deviceToShow) {
          cta = this.createCTA(this.props.changeItemCTAText,deviceToShow.removeUrl);
          deviceToShow.cta = cta;
        }
      }
    }

    this.setState({
      bundleToShow,
      plansToShow,
      deviceToShow
    });
  }

  createCTA(text, url) {
    let redirectTo = Routing.getQueryParameter('redirectTo', url);

    return {
      text: text,
      action: Routing.getUrlWithoutQuery(url),
      redirectTo: redirectTo ? redirectTo : window.location.href
    };
  }

  render() {
    if (this.state.bundleToShow || this.state.plansToShow || this.state.deviceToShow) {
      return (
        <div className={'eir-cart-container ' + this.props.className}>
          {this.renderBundle()}
          {this.renderPlans()}
          {this.renderDevice()}
        </div>
      );
    } else {
      return null;
    }
  }

  renderBundle = () => {
    if (this.state.bundleToShow) {
      return (
        <h6 className="text-black">
          <span className="mr-1">{this.state.bundleToShow.name}</span>
          {this.renderCTA(this.state.bundleToShow.cta)}
        </h6>
      );
    } else {
      return null;
    }
  };

  renderPlans = () => {
      if (this.state.plansToShow.length == 0) {
        return null;
      } else if (this.state.plansToShow.length == 1) {
        return (
          <h6 className="text-black">
            Selected Plan: <strong className="mr-1">{this.state.plansToShow[0].name}</strong>
            {this.renderCTA(this.state.plansToShow[0].cta)}
          </h6>
        );
      } else {
        return (
          <React.Fragment>
            <h6 className="text-black">Selected Plans:</h6>
            {this.state.plansToShow.map((planToShow, index) => {
              <h6 className="text-black" key={'plan' + index}>
                <strong className="mr-1">{planToShow.name} </strong>
                {this.renderCTA(planToShow.cta)}
              </h6>;
            })}
          </React.Fragment>
        );
      }
  };

  renderDevice = () => {
    if (this.state.deviceToShow) {
      return (
        <h6 className="text-black">
          Selected Device: <strong className="mr-1">{this.state.deviceToShow.name}</strong>
          {this.renderCTA(this.state.deviceToShow.cta)}
        </h6>
      );
    } else {
      return null;
    }
  };

  renderCTA = cta => {
    if (cta) {
      return (
        // need to transform a query string parameter to a form parameter
        <div className="d-inline-block">
          <form action={cta.action} method="post">
            <EirButton
              className="align-baseline"
              name="redirectTo"
              value={cta.redirectTo}
              text={cta.text}
              type="link"
            />
          </form>
        </div>
      );
    } else {
      return null;
    }
  };
}

export default CartSummary;
